import { Box, Pagination } from '@wix/design-system';
import { ReviewsWithPaginationProps } from './types';
import ReviewsList from './ReviewsContent/ReviewsList';

const ReviewsWithPagination = ({
  pageNumber,
  totalPages,
  onPageChange,
  PaginationWrapper,
  reviews,
  isMyProfile,
  services,
  handleBiGenericClick,
  i18nKeys,
  isMobileView,
  replyProps,
  onEdit,
  userReview,
  reviewsCount,
  averageReviewRating,
  listProps,
}: ReviewsWithPaginationProps) => {
  const paginationElement = (
    <Pagination
      dataHook="pagination"
      currentPage={pageNumber}
      totalPages={totalPages}
      onChange={async ({ page, event }) => {
        event.preventDefault();
        onPageChange(page);
      }}
    />
  );

  return (
    <>
      <ReviewsList
        reviews={reviews}
        isMyProfile={isMyProfile}
        services={services}
        handleBiGenericClick={handleBiGenericClick}
        i18nKeys={i18nKeys}
        isMobileView={isMobileView}
        replyProps={replyProps}
        onEdit={onEdit}
        userReview={userReview}
        reviewsCount={reviewsCount}
        averageReviewRating={averageReviewRating}
        {...listProps}
      />

      {reviewsCount > 0 && totalPages > 1 && (
        <Box
          align="center"
          paddingTop="18px"
          margin="auto"
          dataHook="reviews-pagination-container"
        >
          {PaginationWrapper ? (
            <PaginationWrapper>{paginationElement}</PaginationWrapper>
          ) : (
            paginationElement
          )}
        </Box>
      )}
    </>
  );
};

export default ReviewsWithPagination;
